import script from "./BrandedLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./BrandedLayout.vue?vue&type=script&lang=ts&setup=true"

import "./BrandedLayout.vue?vue&type=style&index=0&id=b9872414&lang=postcss"

const __exports__ = script;

export default __exports__